import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(items) {
        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.items_cart_preview');
          itensCartPreview.innerHTML = '';

          items.forEach((item) => {
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';

            let itemHTML = `
            <li class="cart-item">
              <figure>
                <img src="${item.image_medium}" alt="${item.name}">
              </figure>
              <div class="cart-item-content">
                <div class="cart-item-content-item">
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                </div>
                <div class="cart-item-content-item">
                  ${variations}
                  <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
                </div>
              </div>
            </li>
            `;

            itensCartPreview.innerHTML += itemHTML;
          });

          // Adiciona o event listener para os botões de deletar
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function () {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });
        }
      }

      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function (data) {
        if (data && data.cart_data && data.cart_data.items) {
          updateCartPreview(data.cart_data.items);
        }
      });

      $(document).on("ajaxComplete", function (event, xhr, settings) {
        if (settings.url.includes('/api/front/cart/items/') && settings.type === 'POST') {
          let valid_status = [200, 201];
          if (valid_status.includes(xhr.status)) {
            const responseJson = xhr.responseJSON.cart_data.items;
            updateCartPreview(responseJson);
          }
        }
      });
    },
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

waitForElementToExist('.banner-instagram').then(element => {
  const instagramBanner = element.querySelector('#js-carrousel-instagram');
  if (instagramBanner) {
    $('#js-carrousel-instagram').slick({
      arrows: false,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToScroll: 6,
            slidesToShow: 6,
          }
        },
      ]
    });

    $('#js-carrousel-instagram').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      Blazy({
        selector: '.lazy-img',
        successClass: 'loaded-img',
        success: function (element) {
          setTimeout(function () {
            var parent = element.previousSibling;
            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
          }, 200);
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {

   const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        if (mutation.attributeName === "class") {
            const target = mutation.target;
            if (target.classList.contains("active")) {
                const elementsToRemove = target.querySelectorAll(".product-item__content--figure .product-item__options");
                elementsToRemove.forEach(el => el.remove());
            }
        }
    });
});

document.querySelectorAll(".shoppub-fast-buy-popup").forEach(popup => {
    observer.observe(popup, { attributes: true, attributeFilter: ["class"] });
}); 

  if (view_origin == "cart") {
    function extractNumber(str) {
      return parseFloat(str?.replace(/[^\d.,-]/g, '').replace(',', '.')) || 0;
    }
  
  
    const getAllProductsCart = () => {
      const products = [];
      const allProducts = document.querySelectorAll('.cart__item:not(.cart--gift)');
      let totalPrice = 0;
      const couponInput = document.querySelector('#js_form_coupon .form__text.cupon--text');
      const coupon = couponInput ? couponInput.value : '';
  
      allProducts.forEach(item => {
        const isB2B = item.classList.contains('is_b2b');
        const sku = item.getAttribute('data-product-sku') || '';
        const name = item.getAttribute('data-product-name') || '';
        const brand = item.getAttribute('data-product-brand-name') || '';
  
        if (isB2B) {
          const gridItems = item.querySelectorAll('.behaviour-grid__amounts--qtt');
  
          gridItems.forEach(grid => {
            const quantityInput = grid.querySelector('.js_cart_item_quantity');
            const quantity = quantityInput ? Number(quantityInput.value) : 1;
            const oldPrice = quantityInput ? extractNumber(quantityInput.getAttribute('data-product-price-de')) : 0;
            const actualPrice = quantityInput ? extractNumber(quantityInput.getAttribute('data-product-price-por')) : 0;
            const variantLabel = grid.querySelector('.behaviour-grid__amounts--label');
            const variant = variantLabel ? variantLabel.getAttribute('data-product-variant') : '';
  
            const discount = oldPrice > actualPrice ? parseFloat((oldPrice - actualPrice).toFixed(2)) : 0;
            const finalPrice = oldPrice > actualPrice ? oldPrice : actualPrice;
  
            products.push({
              item_id: sku,
              item_name: name,
              item_brand: brand,
              item_variant: variant,
              discount,
              price: finalPrice,
              quantity,
            });
  
            totalPrice = Number((totalPrice + (actualPrice * quantity)).toFixed(2));
          });
        } else {
          const quantityInput = item.querySelector('.js_cart_item_quantity');
          const quantity = quantityInput ? Number(quantityInput.value) : 1;
          const variant = item.getAttribute('data-variant') || '';
          const isGift = item.hasAttribute('data-product-brinde');
  
          const oldPrice = isGift ? 0 : extractNumber(item.getAttribute('data-product-price-de')) || 0;
          const actualPrice = isGift ? 0 : extractNumber(item.getAttribute('data-product-price')) || 0;
  
          const discount = oldPrice > actualPrice ? parseFloat((oldPrice - actualPrice).toFixed(2)) : 0;
          const finalPrice = oldPrice > actualPrice ? oldPrice : actualPrice;
  
          products.push({
            item_id: sku,
            item_name: name,
            item_brand: brand,
            item_variant: variant,
            discount,
            price: finalPrice,
            quantity,
          });
  
          totalPrice = Number((totalPrice + ((finalPrice - discount) * quantity)).toFixed(2));
        }
      });
  
      return { product: products, price: totalPrice, coupon };
    };
  
  
    $('body').on('click', '.btn__cart__close_cart', function (event) {
      sessionStorage.setItem("arrayItems", JSON.stringify(getAllProductsCart()));
    });
    
  }


  const containerShoppub = document.querySelector('#dynamic-page-extra .main-content .container-shoppub');
  if (containerShoppub) {
    const collection = document.querySelector('#dynamic-page-extra .collection');
    const pageManifesto = document.querySelector('#dynamic-page-extra .manifesto');
    const aboutUs = document.querySelector('#dynamic-page-extra .about-us');
    const inside = document.querySelector('#dynamic-page-extra .inside');
    const blackTie = document.querySelector('#dynamic-page-extra .blacktie');

    if (pageManifesto || collection || aboutUs || inside || blackTie) {
      containerShoppub.classList.add('page-front');
    }
  }

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {
    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var $el = $(el);
      if ($el.visible(true)) {
        $el.addClass("widget-loaded");
        $el.children().trigger("mouseenter");

        setTimeout(() => {
          const domEl = el;
          const appendColors = domEl.querySelector('.append-colors');
          const colorsVariation = domEl.querySelector('.product__colors');

          if (appendColors && colorsVariation) {
            const cloneColorsVariation = colorsVariation.cloneNode(true);
            appendColors.appendChild(cloneColorsVariation);
          }
        }, 1000);

        $el.on("click", "input[id^='product_item_variation__product_detail']", function () {
          var input = $(this);
          var inputId = input.attr("id");
          var label = $el.find("label[for='" + inputId + "']");

          if (label.length && !label.hasClass("out-of-stock")) {
            setTimeout(function () {
              $el.find(".js-button-add-product-to-cart__product-list").trigger("click");
            }, 500);
          }
        });
      }
    });
  }

  // Adicionar mais eventos para melhor compatibilidade mobile
  $(window).on('scroll mousemove touchstart touchmove touchend', function () {
    loadWidgets();
  });
  

  function selectVariation(id, parent) {
    axios.get(`/api/front/product/${id}/get-linked-product/`).then(res => {
      const isProductItem = parent.classList.contains('product-item') ? true : false;
      const isModalPopup = parent.classList.contains('shoppub-fast-buy-popup') ? true : false;
      let productName = '';
      let radioVariations = '';
      let getBody = '';
      let dataIdAuto = '';
      //seleciona os elementos a serem alterados
      if (isProductItem) {
        productName = parent.querySelector('.product-item__content--figcaption-name a');
        radioVariations = parent.querySelector(".product-item__options .product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = parent.querySelector('.product-radio-variation input') ? parent.querySelector('.product-radio-variation input').getAttribute('data-id-auto') : '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else if (isModalPopup) {
        productName = parent.querySelector('.product-item__content--figcaption-name a');
        radioVariations = parent.querySelector(".product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = parent.querySelector('.product-radio-variation input') ? parent.querySelector('.product-radio-variation input').getAttribute('data-id-auto') : '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else {
        productName = parent.querySelector('#js-product_name__product_detail_');
        radioVariations = parent.querySelector(".product-detail__header--infoArea-kit .product-radio-variation");
        getBody = document.querySelector('body');
      }

      const linkName = "/produto/" + res.data.slug;

      //troca o nome do produto
      if (productName) {
        productName.innerHTML = res.data.name
        if (productName.tagName.toLowerCase() === 'a') {
          //substitui o link href da tag a (ainda experimental pois há variaveis, nao funciona sempre)
          productName.href = linkName;
        }
      }

      // só as ativas entram; sem estoque continua aparecendo, mas como out-of-stock
      const activeVariations = res.data.variations.filter(variation => variation.active);

      if (res.data.variations.length > 0) {
        $(radioVariations).html('');
        if (radioVariations && !isProductItem && activeVariations.length > 0) {
          $(radioVariations).append('<p class="label_attributes"> escolha o tamanho </p>');
        }
        activeVariations.forEach(function (variation) {
          const radioInput = $(`<input type="radio" name="product_item_variation__product_detail_${dataIdAuto}_${res.data.id}" id="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" value="${variation.id}" data-id-auto="${dataIdAuto}" data-variation-name="${variation.main_attribute.name}" data-origin-location="product_detail">`);

          const radioLabel = $(`<label for="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" class="label_radio ${!variation.available ? "out-of-stock" : ""} radio"><span>${variation.main_attribute.value}</span></label>`);

          radioLabel.on('click', function () {
            getBody.setAttribute('data-id-current', variation.id)
          });

          $(radioVariations).append(radioInput).append(radioLabel);
        })
      }

      if (isProductItem) {
        const figure = parent.querySelector('.product-item__content .product-item__content--figure a');
        figure.href = linkName;
        // let price = parent.querySelector('.product-item__content .price');

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            const mouseoverImg = res.data.images[5];
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img ${!mouseoverImg ? "no-hover" : ""} b-error"> <span class="product-item__content--figure-loading"></span>${mouseoverImg ? `<img src="${mouseoverImg}" alt="${res.data.name}" class="block-img lazy-img second b-error">` : ''}</a>`;
          }
        }

        // const formatadorBRL = new Intl.NumberFormat('pt-BR', {
        //   style: 'currency',
        //   currency: 'BRL'
        // });

        // let a_vista_label = res.data.a_vista_label; 
        // let preco_de = formatadorBRL.format(res.data.preco_de);
        // let preco_por = formatadorBRL.format(res.data.price_with_discounts.only_first_installment);
        // let preco_a_vista = formatadorBRL.format(res.data.price_with_discounts.except_first_installment);
        // let parcelas_sem_juros_label = res.data.parcelas_sem_juros_label;
        // let preco_parcelado_label = formatadorBRL.format(res.data.preco_parcelado_label);
        // let priorizar_parcelas_sem_juros = res.data.priorizar_parcelas_sem_juros;
        // let max_parcelas = res.data.parcelas.max_parcelas_sem_juros;
        // let valor_parcela_sem_juros = formatadorBRL.format(res.data.parcelas.valor_parcela_sem_juros);

        // // Verifica se deve mostrar o preço de
        // let mostrarPrecoDe = res.data.preco_de !== res.data.price_with_discounts.only_first_installment;

        // if (price) {
        //   if (priorizar_parcelas_sem_juros) {
        //     price.innerHTML = `
        //        <span class="installment">até ${max_parcelas}x de ${valor_parcela_sem_juros} ${parcelas_sem_juros_label}</span>
        //        <div class="price-group">
        //           <span class="in-cash">${preco_a_vista} lala ${a_vista_label}</span>
        //            ${mostrarPrecoDe ? `<span class="price-of">${preco_de}</span>` : ''}
        //         </div>`;
        //   } else {
        //     price.innerHTML = `
        //         <span class="installment">até ${max_parcelas}x de ${valor_parcela_sem_juros} ${preco_parcelado_label}</span>
        //         <div class="price-group">
        //           <span class="in-cash">${preco_a_vista} lala ${a_vista_label}</span>
        //           ${mostrarPrecoDe ? `<span class="price-of">${preco_de}</span>` : ''}
        //         </div>`;
        //   }
        // }
      } else if (isModalPopup) {
        const figure = parent.querySelector('.product-item__content--figure a');
        figure.href = linkName;

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span></a>`;
          }
        }
      } else {
        const keepBuyingName = document.querySelector('#js-product_name__product_detail_keeping_buying');
        const keepBuyingImage = document.querySelector('.keeping-buying__figure--image');

        if (keepBuyingName && keepBuyingImage) {
          keepBuyingName.innerHTML = res.data.name;
          keepBuyingImage.setAttribute('src', `${res.data.images[0]}`);
        }

        if ($('.mobile-slider .slider-single').hasClass('slick-initialized')) {
          $('.mobile-slider .slider-single').slick('unslick');
        }
        if ($('.mobile-slider .slider-nav').hasClass('slick-initialized')) {
          $('.mobile-slider .slider-nav').slick('unslick');
        }

        $('.product-detail__header--photoArea-mobile').slick('removeSlide', null, null, true);
        $('.product-detail__header--photoArea-photo ul').html('');
        $('.product-detail__header--photoArea-thumbs-default ul').html('');
        $('.mobile-slider .slider-single').html('');
        $('.mobile-slider .slider-nav').html('');
        if (res.data.images.length > 0) {
          res.data.images.forEach(function (image, index) {
            $('.product-detail__header--photoArea-mobile').slick('slickAdd', `<li style="width: 100%;"><a href="${image}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-photo ul').append(`<li class="sp-wrap" id="photo-${index}"><a href="${image}" data-gallery="gallery1"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-thumbs-default ul').append(`<li class="sp-wrap" id="photo-${index}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></li>`);
            $('.mobile-slider .slider-single').append(`<a href="${image}" data-gallery="gallery3"><img src="${image}"/></a>`);
            $('.mobile-slider .slider-nav').append(`<li><img src="${image}"/></li>`);
          });
        }

        moveThumbs();

        $('.mobile-slider .slider-single').slick({
          swipeToSlide: true,
          touchThreshold: 100,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          fade: false,
          infinite: false,
          mobileFirst: true,
          speed: 700,
          vertical: false,
          responsive: [
            {
              breakpoint: 991,
              settings: "unslick"
            },
          ]
        });

        $('.mobile-slider .slider-nav').slick({
          swipeToSlide: true,
          touchThreshold: 100,
          slidesToShow: 4, // ou quantas thumbs quiser mostrar
          slidesToScroll: 1,
          asNavFor: '.slider-single',
          focusOnSelect: true,
          centerMode: false, // opcional
          arrows: false, // ou false se quiser ocultar as setas
          infinite: false,
          mobileFirst: true,
          speed: 700,
          vertical: false,
          responsive: [
            {
              breakpoint: 991,
              settings: "unslick"
            },
          ]
        });
      }

      if (getBody) {
        getBody.setAttribute('data-id', `${id}`);
        getBody.setAttribute('data-id-current', `${id}`);
      }
    }).catch(err => { console.log(err); });
  }

  if(view_origin != "detalhe_produto") {
    // o .product__colors é clonado para dentro do .append-colors, então o mesmo
    // card tem mais de um container com os mesmos variation-id
    function highlightSelectedColor(parent, variationId) {
      parent.querySelectorAll('.product__colors-item').forEach(option => {
        option.classList.toggle('is-selected', option.getAttribute('variation-id') === variationId);
      });
    }

    document.body.addEventListener('click', function (event) {
      const targetColor = event.target.closest('.product__colors-item');
      if (!targetColor) return; // se não clicou em cor, sai

      event.preventDefault(); // ✅ impede o redirecionamento do <a>

      const isProductItem = targetColor.closest('.product-item');
      const isModalPopup = targetColor.closest('.shoppub-fast-buy-popup');
      const parent = isProductItem || isModalPopup;

      if (!parent) return;

      const selected = targetColor.getAttribute('variation-id');
      highlightSelectedColor(parent, selected);
      selectVariation(selected, parent);
    });
  }
  
  
});